module.exports = __webpack_public_path__ + "static/futur-call-1-654ac65acb9ed81ceb130a57a9d5bdb3.jpg";